<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <slot/>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="sales"
      class="elevation-1"
      item-key="id"
      :pagination.sync="pagination"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td
          :class="`text-xs-${name.align}`"
          v-for="(name, index) in headers.filter(x => x.text !== 'Actions')"
          :key="index"
        >
          <div v-if="isDateColumn(name.value)">{{props.item[name.value] | formatDate}}</div>
          <div v-else>{{ props.item[name.value] }}</div>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import mockSalesVolume from "@/helpers/mockSalesVolumeSummary";
export default {
  mame: "CustomerOrders",
  data() {
    return {
      sales: mockSalesVolume
    };
  },
  computed: {
    headers: function() {
      return this.getHeaders(this.sales[0]).filter(x => x.text !== "Actions");
    }
  },
  methods: {}
};
</script>

<style scoped>
</style>
